import { FC, useContext } from 'react';

import { Separator } from '@smartshell/ui-kit';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { BookingMore, OnlineBooking, SelfCancel, Workload } from './components';

export const Reservation: FC = () => {
  const { t } = useContext(LocalizationContext);
  return (
    <SettingsBlock title={t('setting.onlineBooking')}>
      <SettingsFrame>
        <OnlineBooking />

        <Separator />

        <SelfCancel />

        <Separator />

        <Workload />

        <Separator />

        <BookingMore />
      </SettingsFrame>
    </SettingsBlock>
  );
};
